<template>
	<div class="content">
		<div class="content_head">
			<button class="button add" :class="{'gray':vipLevl.length==4}" type="button" @click="Edit='add'" :disabled="vipLevl.length==4">+新增会员等级</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>原价</th>
						<th>现价</th>
						<th>借书数量</th>
						<th>线上数量</th>
						<th>会员数量</th>
						<th>
							会员标签
						</th>
						<th>设置</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in vipLevl">
						<td>
							{{index+1}}
						</td>
						<td>
							{{i.originalPrice}}
						</td>
						<td>
							{{i.Price}}
						</td>
						<td>
							{{i.booksCount +'本'}}
						</td>
						<td>
							{{i.wechatCount +'本'}}
						</td>
						<td>
							{{i.count +'人'}}
						</td>
						<td>
							{{i.vipTag }}
						</td>
						<td>
							<button type="button" :class="{'disabled':i.vipLevlID==1}" :disabled="i.vipLevlID==1" class="button" @click='updateVipLevl(i)'>
								编辑
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="edit" v-show="Edit!=''">
			<div>
				<p>
					<label>
						<span class="red">*</span>会员原价:
						<input type="text" v-model="originalPrice" placeholder="会员原价" />
						<span class="err">{{originalPrice>0?'':'×'}}</span>
					</label>
				</p>
				<p>
					<label>
						<span class="red">*</span>会员现价:
						<input type="text" v-model="Price" placeholder="会员现价" />
						<span class="err">{{Price>0?'':'×'}}</span>
					</label>
				</p>
				<p>
					<label>
						<span class="red">*</span>借书数量:
						<input type="text" v-model="booksCount" placeholder="会员借书数量" />
						<span class="err">{{booksCount>0?'':'×'}}</span>
					</label>
				</p>
				<p>
					<label>
						<span class="red">*</span>微信数量:
						<input type="text" v-model="wechatCount" placeholder="会员线上借书数量" />
						<span class="err">{{wechatCount>=0?'':'×'}}</span>
					</label>
				</p>
				<p>
					<label>
						<span class="red">&nbsp;</span>会员特性:
						<input type="text" v-model="vipTag" placeholder="会员特性" />

					</label>
				</p>
				<p>
					<button class="button" :class="{'disabled':!checViplevl}" :disabled="!checViplevl" @click="editvipLevl">{{Edit=='add'? '添加':'修改'}}</button>
					<button class="button" @click="cancel">取消</button>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'vipLevl',
		data() {
			return {
				vipLevl: [],
				Edit: '',
				getData: {},
				clear: {},
				vipLevlID: 0,
				originalPrice: 0,
				Price: 0,
				booksCount: 0,
				vipTag: '',
				wechatCount:6
			};
		},
		created() {
			this.getData = function() {
				this.$request.request({
					url: 'Customer/getVipLevl',
					data: {

					},
					method: 'post'
				}).then(res => {
					if (res.result)
						this.vipLevl = res.vipLevl;
				});
			}
			this.clear = function() {
				this.originalPrice = 0;
				this.VipLevlID = 0;
				this.Price = 0;
				this.booksCount = '';
				this.vipTag = '';
				this.wechatCount = 6;
			}
			this.getData();

		},
		methods: {
			cancel() {
				this.Edit = '';
				this.clear();
			},
			editvipLevl() {
				this.Edit = '';
				this.$request.request({
					url: 'Customer/editVipLevl',
					data: {
						VipLevlID: this.VipLevlID,
						originalPrice: this.originalPrice,
						Price: this.Price,
						booksCount: this.booksCount,
						vipTag: this.vipTag,
						wechatCount:this.wechatCount
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.$uil.showMessage({
							text: res.message
						});
						this.clear();
						this.getData();
					}
				});
			},
			updateVipLevl(i) {
				this.Edit='update';
				this.VipLevlID = i.vipLevlID;
				this.originalPrice = i.originalPrice;
				this.Price = i.Price;
				this.booksCount = i.booksCount;
				this.vipTag = i.vipTag;
				this.wechatCount=i.wechatCount;
			}
		},
		computed: {
			checViplevl() {

				return this.originalPrice > 0 && this.Price > 0 && this.booksCount > 0 ;
			}

		},
		filters: {

		}

	}
</script>

<style>
</style>
